import React from 'react';
import { MenuItem, Select, SelectChangeEvent } from '@mui/material';

import collections from 'data/collections';
import { findCollection } from 'types/Collection';
import { useCollection } from 'utils/useCollection';

const CollectionPicker: React.FC = () => {
  const { collection, setCollection } = useCollection();

  const handleOnChange = (e: SelectChangeEvent<unknown>) => {
    const selectedCollection = findCollection(collections, e.target.value as string);
    setCollection(selectedCollection, true);
  };

  return (
    <Select value={collection?.id || ''} onChange={handleOnChange} displayEmpty>
      <MenuItem value="" disabled>
        Select Collection
      </MenuItem>
      {collections.map((c) => (
        <MenuItem value={c.id} key={c.id}>
          {c.name}
        </MenuItem>
      ))}
    </Select>
  );
};

export default CollectionPicker;
